import React, {
    FC,
    useEffect,
    useState,
} from "react";
import {
    Card,
    CircularProgress,
} from "@mui/material";
import {useCompare} from "./CompareContext";
import {fetchMotorcyclesByIds} from "../../../api/apiService";
import {MotorcycleCompareTable} from "./MotorcycleCompareTable";
import {BackButton} from "../../buttons/BackButton";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {motorcycleDetailsConfig} from "../details/motorcycleDetailsConfig";
import {NoData} from "../../table/NoData";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {RoutesPath} from "../../../enums/RoutesPath";
import {useLocation} from "react-router-dom";

export const CompareList: FC = () => {
    const {compareArray, toggleCompareArray} = useCompare();
    const [motorcycles, setMotorcycles] = useState<IMotorcycle[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const compareIdsFromUrl = urlParams.get("ids");

        if (compareIdsFromUrl && compareArray.length === 0) {
            const ids = compareIdsFromUrl.split(",");
            ids.forEach((id: string) => toggleCompareArray(Number(id)));
        }

        const loadCompareList = async () => {
            if (compareArray.length > 0) {
                try {
                    const ids = compareArray.join(",");
                    const data = await fetchMotorcyclesByIds(ids);
                    setMotorcycles(data);
                } catch (error) {
                    console.error("Error fetching motorcycles:", error);
                } finally {
                    setLoading(false);
                }
            }
            else if (!compareIdsFromUrl && compareArray.length === 0) {
                setLoading(false);
            }
        };

        loadCompareList();
    }, [compareArray, location.search, toggleCompareArray]);

    const handleRemoveMotorcycle = (id: number) => {
        toggleCompareArray(id);
    };

    if (loading) {
        return <CircularProgress/>;
    }

    if (motorcycles.length === 0) {
        return (
            <NoData
                messageLocaId={IdlocaGeneric.no_compare_list}
                redirectButtonLocaId={IdlocaGeneric.go_to_catalogue}
                redirectUrl={RoutesPath.CATALOGUE}
            />
        );
    }

    return (
        <Card sx={{
            padding: {xs: 1, sm: 1, md: 3}, boxShadow: 3,
            borderRadius: 2,
            mt: 2,
            overflow: "hidden",
            backgroundColor: theme => theme.palette.card.background,
        }}>
            <BackButton fallbackUrl={RoutesPath.CATALOGUE}/>
            <MotorcycleCompareTable
                motorcycles={motorcycles}
                onRemoveMotorcycle={handleRemoveMotorcycle}
                motorcycleDetailsConfig={motorcycleDetailsConfig}
            />
        </Card>
    );
};
